import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

import { AlertComponent } from '@sharedComponents/alert/alert';
import { AlertType } from '../enums/alert-type';
import { IconType } from '../enums/icon-type';


@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private _snackBar = inject(MatSnackBar);
  private _baseConfig: MatSnackBarConfig = {
    duration: 6000,
    horizontalPosition: 'right',
    verticalPosition: 'bottom'
  };

  info(message: string, title?: string): void {
    const data = { message, title, icon: IconType.INFO };
    this._openAlert(AlertType.INFO, data);
  }

  success(message: string, title?: string): void {
    const data = { message, title, icon: IconType.SUCCESS };
    this._openAlert(AlertType.SUCCESS, data);
  }

  warning(message: string, title?: string): void {
    const data = { message, title, icon: IconType.WARNING };
    this._openAlert(AlertType.WARNING, data);
  }

  error(message: string, title?: string): void {
    const data = { message, title, icon: IconType.ERROR };
    this._openAlert(AlertType.ERROR, data);
  }

  private _openAlert(type: string, data: any): void {
    data.message = data.message.length > 150 ? `${ data.message.substring(0, 147) }...` : data.message;
    const config: MatSnackBarConfig = {
      ...this._baseConfig,
      panelClass: [type],
      data
    };
    this._snackBar.openFromComponent(AlertComponent, config);
  }
}
